// ============================================================================
// WAC-TP-MediaGallery: Map + Photo Gallery logic
// Exposed: window.WAC_TP_initRouteMap, window.WAC_TP_initRoutePhotos
// ============================================================================
(function() {

  // === HELPER: show map in main slot, hide photo ===
  function showMapInMain() {
    var gallery = document.getElementById('tp-media-gallery');
    var mapEl = document.getElementById('tp-route-map');
    var photoEl = document.getElementById('tp-media-main-photo');
    var photoCredit = document.getElementById('tp-photo-credit');

    if (mapEl) mapEl.style.display = '';
    if (photoEl) photoEl.style.display = 'none';
    if (photoCredit) photoCredit.innerHTML = '';
    if (gallery) gallery.classList.remove('showing-photo');

    // Update active thumb
    var thumbs = document.querySelectorAll('.tp-media-thumb');
    thumbs.forEach(function(t) { t.classList.remove('is-active'); });
    var mapThumb = document.querySelector('.tp-media-thumb-map');
    if (mapThumb) mapThumb.classList.add('is-active');
  }

  // === MAP EXPAND/REDUCE BUTTON ===
  document.addEventListener('click', function(e) {
    if (e.target.id === 'tp-map-expand-btn' || e.target.closest('#tp-map-expand-btn')) {
      var mapEl = document.getElementById('tp-route-map');
      var btn = document.getElementById('tp-map-expand-btn');
      var sidebar = document.querySelector('.tp-media-sidebar');
      var gallery = document.getElementById('tp-media-gallery');
      if (mapEl && btn) {
        var isExpanded = mapEl.classList.toggle('is-expanded');
        gallery.classList.toggle('map-expanded', isExpanded);

        // Update button text and icon
        var btnText = btn.querySelector('span');
        if (btnText) {
          btnText.textContent = isExpanded ? 'Reduce map' : 'Expand map';
        }
        // Swap icon
        var svg = btn.querySelector('svg');
        if (svg) {
          if (isExpanded) {
            // Reduce icon (arrows pointing inward)
            svg.innerHTML = '<path d="M4 14h6v6M14 4h6v6M4 14l7-7M20 4l-7 7"/>';
          } else {
            // Expand icon (arrows pointing outward)
            svg.innerHTML = '<path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>';
          }
        }

        if (sidebar) sidebar.style.display = isExpanded ? 'none' : '';
        if (gallery) gallery.style.gridTemplateColumns = isExpanded ? '1fr' : '';
        showMapInMain();
        if (window.wacRouteMap) {
          setTimeout(function() { window.wacRouteMap.invalidateSize(); }, 350);
        }
      }
    }
  });

  // === MEDIA TAB SWITCHING (WAC pre-built routes) ===
  document.addEventListener('click', function(e) {
    var tab = e.target.closest('.tp-media-tab');
    if (!tab) return;
    var tabId = tab.dataset.tab;
    var container = tab.closest('.tp-route-media-container');
    if (!container) return;
    container.querySelectorAll('.tp-media-tab').forEach(function(t) { t.classList.remove('is-active'); });
    tab.classList.add('is-active');
    container.querySelectorAll('.tp-media-panel').forEach(function(p) { p.classList.remove('is-active'); });
    var panel = document.getElementById('tp-panel-' + tabId);
    if (panel) panel.classList.add('is-active');
    if (tabId === 'map' && window.wacRouteMap) {
      setTimeout(function() { window.wacRouteMap.invalidateSize(); }, 100);
    }
  });

  // === ROUTE MAP INITIALIZATION ===
  function initRouteMap(mapData) {
    var container = document.getElementById('tp-route-map');
    if (!container || !window.L) {
      console.warn('[Gallery] Map container or Leaflet not found');
      return;
    }
    if (!mapData.center || mapData.center.lat == null || mapData.center.lon == null) {
      console.warn('[Gallery] Map data missing valid center coordinates');
      return;
    }
    var validRouteLine = (mapData.route_line || []).filter(function(c) {
      return c && c.length === 2 && c[0] != null && c[1] != null;
    });
    var validWaypoints = (mapData.waypoints || []).filter(function(wp) {
      return wp && wp.coords && wp.coords.length === 2 && wp.coords[0] != null && wp.coords[1] != null;
    });
    if (window.wacRouteMap) {
      window.wacRouteMap.remove();
      window.wacRouteMap = null;
    }
    var map = L.map('tp-route-map').setView([mapData.center.lat, mapData.center.lon], 7);
    window.wacRouteMap = map;
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19
    }).addTo(map);
    if (validRouteLine.length > 1) {
      L.polyline(validRouteLine, { color: '#000', weight: 8, opacity: 0.2 }).addTo(map);
      L.polyline(validRouteLine, { color: '#D62828', weight: 5, opacity: 0.9, lineCap: 'round', lineJoin: 'round' }).addTo(map);
    }
    validWaypoints.forEach(function(wp, index) {
      var isStart = wp.type === 'start' || index === 0;
      var isEnd = wp.type === 'end' || index === validWaypoints.length - 1;
      var locationNum = wp.leg || (index + 1);
      var icon;
      if (isStart) {
        icon = L.divIcon({ className: 'tp-map-marker', html: '<div class="tp-map-emoji">\uD83D\uDE90</div>', iconSize: [32, 32], iconAnchor: [16, 16] });
      } else if (isEnd) {
        icon = L.divIcon({ className: 'tp-map-marker', html: '<div class="tp-map-emoji">\uD83C\uDFC1</div>', iconSize: [32, 32], iconAnchor: [16, 16] });
      } else {
        icon = L.divIcon({ className: 'tp-map-marker', html: '<div class="tp-map-pin"><span>' + locationNum + '</span></div>', iconSize: [28, 28], iconAnchor: [14, 28] });
      }
      var marker = L.marker(wp.coords, { icon: icon }).addTo(map);
      marker.bindTooltip(wp.name, { permanent: false, direction: 'top', offset: [0, -20] });
    });
    if (validRouteLine.length > 1) {
      map.fitBounds(validRouteLine, { padding: [40, 40] });
    }
    console.log('[Gallery] Map initialized with', validWaypoints.length, 'waypoints');
  }

  // === ROUTE PHOTOS INITIALIZATION ===
  // 2-col layout: map in main slot (left), thumbs grid (right, 3 cols).
  // Hover thumb -> swap main slot to that photo. Map thumb returns to map.
  // "More photos" button paginates if >8 photo thumbs.
  function initRoutePhotos(photos, hasMap) {
    var thumbsContainer = document.getElementById('tp-media-thumbs');
    var mainPhoto = document.getElementById('tp-media-main-photo');
    var mainImg = document.getElementById('tp-media-main-img');
    var mapEl = document.getElementById('tp-route-map');
    var photoCredit = document.getElementById('tp-photo-credit');
    var gallery = document.getElementById('tp-media-gallery');
    var nextBtn = document.getElementById('tp-thumb-next');
    if (!thumbsContainer) return;

    var validPhotos = photos.filter(function(item) {
      return item.photo && item.photo.url_regular;
    });

    if (validPhotos.length === 0) return;

    thumbsContainer.innerHTML = '';
    var thumbPage = 0;
    var photoThumbsPerPage = hasMap ? 8 : 9;
    var totalPhotoPages = Math.ceil(validPhotos.length / photoThumbsPerPage);

    if (hasMap) {
      var mapThumb = document.createElement('div');
      mapThumb.className = 'tp-media-thumb tp-media-thumb-map is-active';
      // Map icon SVG instead of text
      mapThumb.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l5.447 2.724A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"/></svg>';
      mapThumb.addEventListener('mouseenter', function() { showMapInMain(); });
      mapThumb.addEventListener('click', function() { showMapInMain(); });
      thumbsContainer.appendChild(mapThumb);
    }

    function renderPhotoThumbs(page) {
      var existing = thumbsContainer.querySelectorAll('.tp-media-thumb:not(.tp-media-thumb-map)');
      existing.forEach(function(t) { t.remove(); });

      var start = page * photoThumbsPerPage;
      var end = Math.min(start + photoThumbsPerPage, validPhotos.length);
      var slice = validPhotos.slice(start, end);

      slice.forEach(function(item) {
        var thumb = document.createElement('div');
        thumb.className = 'tp-media-thumb';
        thumb.innerHTML = '<img src="' + item.photo.url_small + '" alt="' + (item.photo.alt || item.location) + '">';

        function showThisPhoto() {
          if (mapEl) mapEl.style.display = 'none';
          if (mainPhoto) mainPhoto.style.display = 'block';
          if (mainImg) {
            mainImg.src = item.photo.url_regular;
            mainImg.alt = item.photo.alt || item.location;
          }
          // Show photo credit under image
          if (photoCredit) {
            var credit = '';
            if (item.photo.attribution) {
              credit = 'Day ' + item.day + ' \u00B7 ' + item.location + ' \u00B7 <a href="' + item.photo.attribution.pixabay_url + '" target="_blank" rel="noopener">' + item.photo.attribution.text + '</a>';
            } else {
              credit = 'Day ' + item.day + ' \u00B7 ' + item.location;
            }
            photoCredit.innerHTML = credit;
          }
          // Add class to gallery to show photo credit, hide expand button
          if (gallery) gallery.classList.add('showing-photo');

          thumbsContainer.querySelectorAll('.tp-media-thumb').forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        }

        thumb.addEventListener('mouseenter', showThisPhoto);
        thumb.addEventListener('click', showThisPhoto);
        thumbsContainer.appendChild(thumb);
      });

      if (nextBtn) {
        var hasMore = totalPhotoPages > 1;
        nextBtn.classList.toggle('is-hidden', !hasMore);
        if (hasMore) {
          var isBack = page >= totalPhotoPages - 1;
          nextBtn.textContent = isBack ? 'Back' : 'More photos';
          nextBtn.classList.toggle('is-back', isBack);
        }
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        if (thumbPage < totalPhotoPages - 1) {
          thumbPage++;
        } else {
          thumbPage = 0;
        }
        renderPhotoThumbs(thumbPage);
      });
    }

    renderPhotoThumbs(0);
    console.log('[Gallery] Photos initialized:', validPhotos.length, 'thumbs, pages:', totalPhotoPages);
  }

  // Expose on window for main SuggestedRoute script to call
  window.WAC_TP_initRouteMap = initRouteMap;
  window.WAC_TP_initRoutePhotos = initRoutePhotos;

  console.log('[Gallery] Media gallery loaded');
})();